export class Configuration {
  public authorName: number;
  public modifiedAt: string;
  public isMaintenanceMode: boolean;
  public isSuggestionMode: boolean;

  constructor(
    authorName = 0,
    modifiedAt = "",
    isMaintenanceMode = false,
    isSuggestionMode = false
  ) {
    this.authorName = authorName;
    this.modifiedAt = modifiedAt;
    this.isMaintenanceMode = isMaintenanceMode;
    this.isSuggestionMode = isSuggestionMode;
  }
}
